import React, { ReactNode } from 'react';
import cx from 'clsx';

import { IconRcQuestion, IconRcQuestionGhost } from '@/assets';
import HelperTooltip from '../HelperTooltip';

import style from './index.module.css';

type Props = {
  title: string | JSX.Element;
  className?: string;
  iconClassName?: string;
  overlayClassName?: string;
  children?: ReactNode;
  size?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  ghost?: boolean;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
};

export const Tips: React.FC<Props> = ({
  title,
  className,
  iconClassName,
  children,
  placement,
  overlayClassName,
  size = 12,
  ghost,
  onClick,
}) => {
  const Icon = ghost ? IconRcQuestionGhost : IconRcQuestion;

  return (
    <span className={cx(style.tips, className)} onClick={onClick}>
      {children}
      <HelperTooltip
        title={title}
        arrowPointAtCenter
        placement={placement}
        overlayClassName={overlayClassName}>
        <Icon className={cx(style.icon, iconClassName)} width={size} height={size} />
      </HelperTooltip>
    </span>
  );
};

export default Tips;
